/**
 * Initializer that triggers jQuery event on target element.
 * If data-target is not present, current element is used as target.
 *
 * Usage:
 * <span data-trigger="my.event.name" data-target="#targetElementId"></span>
 */

"use strict";

import $ from 'jquery'

export default function () {
    const el = this;
    $('[data-trigger]', el).each(function() {
        const $this = $(this);
        const eventName = $this.attr('data-trigger');
        let $target = $($this.attr('data-target'));
        if($target.length === 0) {
            $target = $this;
        }
        $target.trigger(eventName);
    });
}


// WEBPACK FOOTER //
// ./node_modules/linksoft/src/initializers/trigger.js